import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import PrintIcon from 'material-ui/svg-icons/action/print';

export default class PrintButton extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div
        style={{ marginLeft: 16, backgroundColor: '#fafafa' }}>
        <FlatButton
          style={{ width: 96, border: '1px solid #dbdee1' }}
          onTouchTap={this.props.onPrint}>

          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <PrintIcon
              color={'#585b5f'}/>

            <span
              style={{
                textTransform: 'none',
                fontSize: 14,
                marginLeft: 16,
              }}>
              Print
            </span>
          </div>
        </FlatButton>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/reports/common/PrintButton.js